
import { computed, defineComponent, PropType, Ref } from 'vue';
import HeroBannerSimple from '@/shared/content/blocks/hero-banner/HeroBannerSimple.vue';
import { HeroBannerSimpleTileModel, ImageFileModel } from '@/types/B2BcontentServerContract';
import pageStore from '@/shared/content/page.store';
import utils from '@/shared/utilities.service';

export default defineComponent({
    name: 'HeroBannerSimpleTile',
    components: { HeroBannerSimple },
    props: {
        content: {
            type: Object as PropType<HeroBannerSimpleTileModel>,
            required: true,
        },
    },
    setup(props) {
        const image: Ref<ImageFileModel> = computed(() => {
            return props.content.media.model;
        });

        const title = computed(() => {
            const altTitle = pageStore.altTitle;
            return altTitle ? utils.formatString(props.content.title, altTitle) : props.content.title;
        });

        return {
            image,
            title,
        };
    },
});
